<div class="page-wrapper section-hr-direct">
    <app-left-menu [showMenu]="false"></app-left-menu>
    <div id="main-container">
        <app-header [showHistoryButton]="true" [claimUri]="claimUri" [showAddClaim]="showAddClaim" [title]="title">
        </app-header>
        <div class="content-header"></div>
        <div class="page-content" id="page-content" style="overflow: auto !important;">

            <div class="no-absolute">
                <div class="pharse" *ngIf="showAddClaim"
                    style="text-align: center;padding-bottom: 10px;font-style:italic">
                    {{'PatientHistory.Pharse1'|translate}}</div>
                <div class="pharse" *ngIf="!showAddClaim"
                    style="text-align: center;padding-bottom: 10px;font-style:italic">
                    {{'PatientHistory.Pharse2'|translate}}
                </div>
                <div class="history"><strong>{{'PatientHistory.Label.PatientID'|translate}}</strong> :
                    #{{patientHistory.User?.UserId}}</div>
                <div class="history"><strong>{{'PatientHistory.Label.PatientName'|translate}} </strong>:
                    {{patientHistory.User?.FullName}}</div>
                <div class="history">
                    <div style="float: left;"><strong> {{'Common.Authorization.Details'|translate}}</strong>
                    </div>
                    <span id="atLeastOneClaim" style="width: 60%;
                    float: left;
                    text-align: center;
                    color: red;" *ngIf="errorMessage">{{'PatientHistory.Message.NotSelected' |translate}}</span>

                    <div style="float: right;" id="divPrint">
                        <ul class="document-links printEnable" style="
                        position: absolute;
                        right: 40px;
                        top: 35px;
                    ">
                            <li *ngIf="!showEmail"><span class="emailorprint" (click)="showEmail=!showEmail">{{'Email or
                                    Print'|translate}}</span></li>
                            <li *ngIf="showEmail"><a class="email" (click)="openDialog()" data-target="#email-document"
                                    data-toggle="modal" href="javascript:void(0)">
                                    <span>Email</span>
                                </a>
                            </li>
                            <li *ngIf="showEmail">
                                <a (click)="print()" class="print" href="javascript:void(0)">
                                    <span>Print</span>
                                </a>
                            </li>
                        </ul>

                    </div>


                </div>
                <table class="table table-bordered" id="table">
                    <thead>
                        <tr>
                            <th> {{'PatientHistory.Table.Header.BasicDetail' | translate}}</th>

                            <th> {{'PatientHistory.Table.Header.Notes' | translate}}</th>
                            <th> {{'PatientHistory.Table.Header.AuthorizationInfo'| translate}}</th>
                            <th> {{'PatientHistory.Table.Header.EOBNotes'| translate}}</th>
                            <th *ngIf="showEmail"> {{'PatientHistory.Table.Header.Action'|translate}}

                                <br>
                                <input type="checkbox" [(ngModel)]="selectedAll" (change)="selectAllClaim()" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr [class.alternate]="i%2!=0" id="{{item.ClaimID}}"
                            *ngFor="let item of patientHistory.PatientHistory; index as i;">

                            <td style="width: 200px;">
                                <div>
                                    <a style="cursor: pointer;" *ngIf="item.IsEditable"
                                        [routerLink]="['/claims/edit',userId,item.ClaimID]"
                                        routerLinkActive="router-link-active">{{ 'Common.Edit'|translate}}</a> <span
                                        *ngIf="item.IsEditable">&nbsp;|&nbsp;</span>
                                    <a style="cursor: pointer;" *ngIf="item.IsEditable" (click)="delete(item)"
                                        routerLinkActive="router-link-active">{{ 'Common.Delete'|translate}}</a>
                                </div>
                                <div>{{'PatientHistory.Table.Header.DateSubmitted'| translate}} :
                                    {{item.DateSubmitted | date:'MM/dd/yyyy'}}</div>

                                <div>{{'PatientHistory.Table.Header.DateOfService' | translate}} :
                                    {{item.DateOfService | date:'MM/dd/yyyy'}}</div>
                                <div>{{'PatientHistory.Table.Header.Status'| translate}} : {{item.Status}}</div>
                                <div>{{'PatientHistory.Table.Header.ClaimedAmount'| translate}} :
                                    {{item.ClaimedAmount| currency}}</div>
                                <hr *ngIf="item.CheckStatus" style="margin-top: 5px;margin-bottom: 5px;">
                                <span *ngIf="item.CheckStatus">{{'PatientHistory.Table.Header.CheckStatus' | translate}}
                                    :</span>
                                <div *ngIf="item.CheckStatus" [innerHtml]="item.CheckStatus"></div>


                            </td>

                            <td style="width: 25%;">
                                <div [innerHtml]="item.EClaimNotes"></div>

                            </td>
                            <td style="width: 25%;">
                                <div [innerHtml]="item.AuthorizationInfo"></div>
                            </td>
                            <td style="width: 25%;">
                                <div [innerHtml]="item.EOBNotes"></div>

                            </td>
                            <td *ngIf="showEmail">
                                <input type="checkbox" [checked]="true" [(ngModel)]="item.selected"
                                    (change)="selectClaim()" />
                            </td>
                            <!-- <td>
                                <a *ngIf="item.IsEditable" [routerLink]="['/claims/edit',userId,item.ClaimID]"
                                    routerLinkActive="router-link-active">Edit</a>
                            </td> -->
                        </tr>

                    </tbody>
                </table>
                <div class="not-found" *ngIf="!(patientHistory.PatientHistory?.length>0)">                  
                        {{"PatientHistory.Message.NotFound" | translate}}
                </div>
            </div>
        </div>
    </div>
</div>